import { useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import { useAuth } from './context/AuthContext'
import { router } from './router'
import LoginPage from './pages/LoginPage'

export default function App() {
  const { isAuthenticated, isLoading } = useAuth()

  useEffect(() => {
    document.documentElement.classList.add('dark')
  }, [])

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-950 via-gray-900 to-gray-800">
        <div className="text-gray-400 animate-pulse text-lg">Loading…</div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <LoginPage />
  }

  return <RouterProvider router={router} />
}
